import React, { useState } from "react";

// Components
import InfluencerCard from "./influencerCard/InfluencerCard";
import MoreInfluencers from "./moreInfluencers/MoreInfluencers";
import AddedInfluencer from "./addedInfluencer/AddedInfluencer";

// Stylesheet
import "./Influencer.css";

//import { DataStore } from "@aws-amplify/datastore";
import { NFTSINFLUENCERS } from "../../../../models";
import firebase from "./../../../../firebase"

// Assets
import influencerImage from "../../../../assets/influencerImage.png";

const Post = React.createContext();

function Influencer({inf,setInfluencer}) {
  const [allInfluencer, setAllInfluencer] = useState([]);
  const [list, setList] = useState([]);
  const defaultList = [
    {
      key: 1,
      src: influencerImage,
      name: "Naman Mathur",
      followers: "20k Followers",
    },
    {
      key: 2,
      src: influencerImage,
      name: "Naman",
      followers: "20k Followers",
    },
    {
      key: 3,
      src: influencerImage,
      name: "Naman Mathur",
      followers: "20k Followers",
    },
    {
      key: 4,
      src: influencerImage,
      name: "Naman",
      followers: "20k Followers",
    },
  ];

  const n = async () => {
     //let t = await DataStore.query(NFTSINFLUENCERS);
      await firebase.firestore().collection('InfluencerDataModel').limit(50).onSnapshot((snapshot) => {
      snapshot.forEach((doc) => 
      {
        const document = doc.data()
        setList(prev => [...prev, document]);
      });
    });
  };
  
  //var list = [];
  React.useEffect(async () => {
      await n();
  }, []);
  
  setInfluencer(allInfluencer);
  
  // Function to add item on button click
  // const addItem = (key) => {};

  const [post, setPost] = useState(null);

  return (
    <div className="influencer-content">
      <div>
        <p className="influencer-heading" onClick={n}>
          Pick Influencers
          <span className="yellow">
            {" "}(Select influencers to promote your NFT, Max 5)
          </span>
        </p>
        <Post.Provider value={{ post, setPost }}>
          <div className="cards influencer-cards">
            {list && list.slice(0, 4) .map((item) => {
              return (
                <div
                  onClick={() => {
                    if (!allInfluencer.find((val) => val.uniqueID === item.uniqueID)) {
                      item.isSold = false;
                      setAllInfluencer([...allInfluencer, item]);
                      console.log(allInfluencer);
                      
                    }
                  }}
                  style={{
                    cursor: "pointer",
                    width: "fit-content",
                    textAlign: "center",
                  }}
                >
                  <InfluencerCard data={item} />
                </div>
              );
            })}


            {list &&
              <MoreInfluencers
                allInfluencerList={list}
                allInfluencer={allInfluencer}
                setAllInfluencer={setAllInfluencer}
              />
            }
          </div>
        </Post.Provider>
      </div>

      {allInfluencer.length != 0 &&
        <div>
          <p className="influencer-heading">
            Added Influencers
            <span className="yellow">
              (You can remove the added influencers if you want)
            </span>
          </p>
          <div className="cards influencer-cards">
            {/* {post === null ? null : <AddedInfluencer content={post} />} */}
            <AddedInfluencer
              setInfluencer={setAllInfluencer}
              influencer={allInfluencer}
            />
          </div>
        </div>
      }
    </div>
  );
}

export { Influencer, Post };
